import React from "react";
import "./HomeAlertModal.scss";
import ModalButton from "../../../common/modalButton/ModalButton";

const HomeAlertModal = ({ title, description, btnText, btnFn, cancelBtnText, cancelBtnFn, isOpen, onClose, btnCss = null }) => {
  if (!isOpen) return null;
  return (
    <div className="home-modal-overlay">
      <div className="home-modal-container">
        <div className="home-modal-content">
          <img
            src="/images/home/home-alert-icon.svg"
            alt="Home Alert Icon"
            className="home-modal-image"
          />
          <h1 className="home-modal-title">{title}</h1>
          <p className="home-modal-subtitle">{description}</p>
          <img
            src="/images/home/close-icon.svg"
            alt="Close"
            className="home-modal-close-icon"
            onClick={onClose}
          />
        </div>
        <div className="home-modal-btn-container">
          {cancelBtnFn && cancelBtnText && <ModalButton buttonText={cancelBtnText} onClick={cancelBtnFn} isSecondary />}
          <ModalButton buttonText={btnText} onClick={btnFn} btnCss={btnCss} />
        </div>
      </div>
    </div>
  );
};

export default HomeAlertModal;